module.exports = __webpack_public_path__ + "img/square_check.1fb693f1.png";